import Shared from '../shared.module.css';
import React, { useState, useEffect } from 'react';
import { IoCalendarOutline } from 'react-icons/io5';
import { collection, getFirestore, onSnapshot, query, where } from 'firebase/firestore';
import { useAppSelector } from 'src/salon/app/hook';
import SessionMake, { SessionEditing } from './make/index';
import SessionCard from './Card';

// 元 10.session/index.tsx から移動。Firestore取得ロジックは変更していない
// (infoSessionsコレクションをcompanyIdで絞り込み、開始時刻の昇順で並べる)。
// 元の画面は company.contract の有無に関わらず表示されていたため、
// (staff/couponタブと違い)ここでは契約チェックによるフォールバックを行わない。
const SessionTab: React.FC = () => {

  const company = useAppSelector((state) => state.company.company);

  const [ sessionList, setSessionList ] = useState<any[]>([]);
  const [ make, setMake ] = useState(false);
  // 「編集する」で開いている説明会
  const [ editing, setEditing ] = useState<SessionEditing | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const db = getFirestore();
    const queryRef = query(
      collection(db, 'infoSessions'),
      where('companyId', '==', company.id)
    );

    const unsub = onSnapshot(queryRef, (snapshot) => {
      const tmp: any[] = snapshot.docs.map((doc) => ({
        id: doc.id,
        name: doc.data().name,
        description: doc.data().description,
        schedule: {
          startAt: doc.data().schedule?.startAt?.toDate ? doc.data().schedule.startAt.toDate() : new Date(doc.data().schedule?.startAt),
          endAt: doc.data().schedule?.endAt?.toDate ? doc.data().schedule.endAt.toDate() : new Date(doc.data().schedule?.endAt),
          durationMin: doc.data().schedule?.durationMin,
        },
        place: doc.data().place,
        people: doc.data().people,
        closed: doc.data().closed === true,
      }));
      tmp.sort((a, b) => a.schedule.startAt - b.schedule.startAt);
      setSessionList(tmp);
    });

    return () => unsub();
  }, [ company.id ]);

  // 説明会ごとの申込数(キャンセルを除く)。学生アプリの「説明会に参加する」の申込(eventEntries)
  const [ entryCounts, setEntryCounts ] = useState<Record<string, number>>({});
  useEffect(() => {
    if (!company.id) return;
    return onSnapshot(
      query(collection(getFirestore(), 'eventEntries'), where('companyId', '==', company.id)),
      (snap) => {
        const counts: Record<string, number> = {};
        snap.docs.forEach((d) => {
          const x = d.data();
          if (x.kind === 'infoSession' && x.status !== 'cancelled') counts[x.targetId] = (counts[x.targetId] ?? 0) + 1;
        });
        setEntryCounts(counts);
      },
      (error) => console.error('説明会の申込数を読み込めませんでした', error),
    );
  }, [ company.id ]);

  return (
    <>
      <div className={Shared.tabHeader}>
        <div>
          <h3 className={Shared.tabHeaderTitle}>会社説明会</h3>
          <p className={Shared.tabHeaderDesc}>会社説明会の情報を掲載し、興味がある学生への訴求を強めます</p>
        </div>
        {sessionList.length > 0 && (
          <button type="button" className={Shared.addButton} onClick={() => setMake(true)}>＋ 説明会を追加する</button>
        )}
      </div>

      {sessionList.length === 0 ? (
        <div className={Shared.emptyState}>
          <div className={Shared.emptyStateIcon}><IoCalendarOutline /></div>
          <p className={Shared.emptyStateTitle}>まだ会社説明会が登録されていません</p>
          <p className={Shared.emptyStateDesc}>説明会の情報を登録すると、興味がある学生との接点を作れます。</p>
          <button type="button" className={Shared.addButton} onClick={() => setMake(true)}>＋ 説明会を追加する</button>
        </div>
      ) : (
        <div className={Shared.cardGrid}>
          {sessionList.map((data) => (
            <SessionCard key={data.id} session={data} entryCount={entryCounts[data.id] ?? 0} onEdit={() => setEditing(data)} />
          ))}
        </div>
      )}

      {make ? <SessionMake setMake={setMake} companyId={company.id} /> : <></> }
      {editing && <SessionMake key={editing.id} setMake={() => setEditing(null)} companyId={company.id} editing={editing} />}
    </>
  );
};

export default SessionTab;
